export const defaultFont = {
  fontFamily: 'Fibel Nord',
  fontSize: '1',
}

export const defaultCalcLayout = 'numpad'
